import { render, staticRenderFns } from "./OrderNumberPage.vue?vue&type=template&id=aeba0032&scoped=true"
import script from "./OrderNumberPage.vue?vue&type=script&lang=js"
export * from "./OrderNumberPage.vue?vue&type=script&lang=js"
import style0 from "./OrderNumberPage.vue?vue&type=style&index=0&id=aeba0032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeba0032",
  null
  
)

export default component.exports